import { Label } from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import PasswordInput from '@/src/components/Password';
import { Form } from 'antd';
import React, { Fragment } from 'react';
import { useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';

export default ({ handleResetInput, unlockEditable, disableEdit }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const params: any = useParams();
  const { uuid } = params;

  return (
    <Fragment>
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='clientId'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.clientID',
                    )}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storePayment.paymentEditPage.clientID'),
                    ),
                  },
                  {
                    type: 'string',
                    min: 10,
                    message: replaceI18nVariables(
                      getI18n(
                        'storePayment.paymentEditPage.fieldValidLengthTooShort',
                      ),
                      getI18n('storePayment.paymentEditPage.clientID'),
                    ),
                  },
                ]}>
                <PasswordInput
                  editable={!uuid || unlockEditable.includes('clientId')}
                  onEdit={() => handleResetInput('clientId')}
                  passwordProps={{ maxLength: 255 }}
                  disabled={disableEdit}
                />
              </Form.Item>
            ),
          },
          {
            child: (
              <Form.Item
                name='apiKey'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n('storePayment.paymentEditPage.aPIKey')}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storePayment.paymentEditPage.aPIKey'),
                    ),
                  },
                  {
                    type: 'string',
                    min: 10,
                    message: replaceI18nVariables(
                      getI18n(
                        'storePayment.paymentEditPage.fieldValidLengthTooShort',
                      ),
                      getI18n('storePayment.paymentEditPage.aPIKey'),
                    ),
                  },
                ]}>
                <PasswordInput
                  editable={!uuid || unlockEditable.includes('apiKey')}
                  onEdit={() => handleResetInput('apiKey')}
                  passwordProps={{ maxLength: 255 }}
                  disabled={disableEdit}
                />
              </Form.Item>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='webhookSecret'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.webhookSecret',
                    )}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storePayment.paymentEditPage.webhookSecret'),
                    ),
                  },
                  {
                    type: 'string',
                    min: 10,
                    message: replaceI18nVariables(
                      getI18n(
                        'storePayment.paymentEditPage.fieldValidLengthTooShort',
                      ),
                      getI18n('storePayment.paymentEditPage.webhookSecret'),
                    ),
                  },
                ]}>
                <PasswordInput
                  editable={!uuid || unlockEditable.includes('webhookSecret')}
                  onEdit={() => handleResetInput('webhookSecret')}
                  passwordProps={{ maxLength: 255 }}
                  disabled={disableEdit}
                />
              </Form.Item>
            ),
          },
          {
            child: '',
          },
        ]}
      />
    </Fragment>
  );
};
